import { render, staticRenderFns } from "./form-tbzt.vue?vue&type=template&id=c0358e62&scoped=true&"
import script from "./form-tbzt.vue?vue&type=script&lang=js&"
export * from "./form-tbzt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0358e62",
  null
  
)

export default component.exports